var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.98 12.488v13.8l6.68-1.34V11.15L.98 12.49zm7.68-1.337V24.95l6.574 1.336V12.487L8.66 11.151zm7.574 1.305v13.779l6.626-1.894V10.56l-6.626 1.895z",
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.385 7.756c0 1.769-.872 4.133-2.172 6.462-1.2 2.15-2.727 4.2-4.149 5.63-1.57-1.42-3.095-3.47-4.253-5.623-1.247-2.32-2.03-4.69-2.03-6.469 0-3.527 2.827-6.377 6.302-6.377 3.475 0 6.302 2.85 6.302 6.377z",
    fill: "#fff",
    stroke: "#000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.083,
    cy: 7.679,
    r: 2.015,
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMap);
export default __webpack_public_path__ + "static/media/menu-map.d04c0912.svg";
export { ForwardRef as ReactComponent };